import {ROOT_URL, MAX_ERROR_TEXT_LEN} from '@/store';

const REQUEST_LINK = '/subscription/set_owner_user/';

function setUserOwner(userId, isOwner, handler) {
  const sendForm = new FormData();
  sendForm.set('set_owner_user_id', userId);
  sendForm.set('set_is_owner', isOwner ? '1' : '0');

  fetch(ROOT_URL + REQUEST_LINK, {
    method: 'POST',
    credentials: 'include',
    body: sendForm,
  }).then(async (response) => {
    if (response.status == 200) {
      handler({
        status: response.status,
        text: 'ok',
      });
      return;
    }

    handler({
      _error: true,
      status: response.status,
      text: `Ошибка установки прав владельца. ${(await response.text()).trimLen(MAX_ERROR_TEXT_LEN)}`,
    });
  }).catch((errData) => {
    handler({
      _error: true,
      status: null,
      text: 'Ошибка подключения к серверу',
    });
  });
}

export default setUserOwner;
